import { render } from "./ReportBuilderUdfPopup.vue?vue&type=template&id=2d3b2f71"
import script from "./ReportBuilderUdfPopup.vue?vue&type=script&lang=js"
export * from "./ReportBuilderUdfPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/report-building/ReportBuilderUdfPopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d3b2f71"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d3b2f71', __exports__)) {
    api.reload('2d3b2f71', __exports__)
  }
  
  module.hot.accept("./ReportBuilderUdfPopup.vue?vue&type=template&id=2d3b2f71", () => {
    api.rerender('2d3b2f71', render)
  })

}


export default __exports__